import { render, staticRenderFns } from "./FechaUbicacion.vue?vue&type=template&id=d2901bca&scoped=true"
import script from "./FechaUbicacion.vue?vue&type=script&lang=js"
export * from "./FechaUbicacion.vue?vue&type=script&lang=js"
import style0 from "./FechaUbicacion.vue?vue&type=style&index=0&id=d2901bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2901bca",
  null
  
)

export default component.exports